module.exports = __webpack_public_path__ + "static/assured-a9cf38b8d0e227916a2271c1085cca68.png";